import { nanoId } from '@/helpers'

const identify = (array) => {
  return array.map(x => {
    if (!x._uid) x._uid = nanoId(5)
    return x
  })
}

export const SET_LIST = (state, value) => {
  state.items = identify(value)
}

export const ADD_TO_LIST = (state, value) => {
  state.items = [
    ...state.items,
    ...identify(value)
  ]
}

export const SET_SELECTION = (state, value) => {
  state.selection = value
}

export const SET_TARGET = (state, value) => {
  state.target = value
}

export const SET_DISABLED = (state, fn) => {
  state.disabled = fn
}

export const SET_EDITABLE = (state, fn) => {
  state.editable = fn
}
